<template>
  <div style="background: #f5f5f5">
    <HeaderView
      :title="xuanfeidata.yn_yu"
      :righticon="'service-o'"
      :rightclick="'toserver'"
      @toserver="toserver()"
    />
    <div class="view-page">
      <van-swipe
        :autoplay="3000"
        v-if="
          xuanfeidata && xuanfeidata.img_url && xuanfeidata.img_url.length > 0
        "
        style="width: 100%"
      >
        <van-swipe-item
          v-for="(image, index) in xuanfeidata.img_url"
          :key="index"
        >
          <img
            v-lazy="image"
            style="height: 400px; width: 100%; object-fit: cover"
          />
        </van-swipe-item>
      </van-swipe>
      <div class="title">
        <van-row>
          <van-col span="8" style="text-align: center; color: #fff">
            <div style="width: 100%;height: 40px;line-height: 40px;">
            {{
            $store.getters.getBaseInfo.name
          }}</div></van-col>
          <van-col span="8">
            <div
              style="
                background: linear-gradient(180deg, #e7caaf, #fff7ed);
                width: 99%;
                margin: 0px auto;
                height: 40px;
                color: #a4826b;
                text-align: center;
                border-bottom-left-radius: 20px;
              "
            >
              <span style="display: flex"
                ><span
                  class="van-badge__wrapper van-icon"
                  style="font-size: 13px"
                  ><img
                    class="van-icon__image"
                    src="../../assets/img/home/vipu.png"
                    style="margin: 13px 0px 0px 10px"
                /></span>
                {{ $t("index.certification") }}</span
              >
            </div>
          </van-col>
          <van-col span="8">
            <div
              style="
                background: linear-gradient(180deg, #e7caaf, #fff7ed);
                width: 99%;
                margin: 0px auto;
                height: 40px;
                color: #a4826b;
                text-align: center;
                border-top-right-radius: 20px;
              "
            >
              <span style="display: flex"
                ><span
                  class="van-badge__wrapper van-icon"
                  style="font-size: 13px"
                  ><img
                    class="van-icon__image"
                    src="../../assets/img/home/vipu.png"
                    style="margin: 13px 0px 0px 10px"
                /></span>
                {{ $t("index.authentication") }}</span
              >
            </div>
          </van-col>
        </van-row>
      </div>
      <div
        style="
          text-align: center;
          font-size: 18px;
          padding: 14px 0px;
          color: rgb(255, 255, 255);
          background-image: linear-gradient(-244deg,rgb(184, 203, 184) 0%,rgb(184, 203, 184) 0%,rgb(180, 101, 218) 0%,rgb(207, 108, 201) 33%,rgb(238, 96, 156) 66%,rgb(238, 96, 156) 100%);
        "
      >
        {{ xuanfeidata.yn_yu }}
      </div>
      <div style="width: 96%;margin: 0px auto 20px auto;">
        <div style="width: 100%;font-size: 16px;font-weight: 800;margin: 20px 0;">
            {{ $t('profile.profile') }}
        </div>
        <div>{{ xuanfeidata.title }}</div>
        <div class="tips" v-if="xuanfeidata && xuanfeidata.tag">
            <span v-for="(t,ti) in xuanfeidata.tag.split('#')" :key="ti" :style="!(t && t.length > 0)?'display:none':''">{{ t }}</span>
        </div>
        <van-row>
            <van-col span="12">{{ $t('index.rating') }}</van-col>
            <van-col span="12" style="text-align: right;"><a style="background: linear-gradient(20deg, #e73266, #ee5380);padding: 4px 10px;border-radius: 6px;color:#fff;" @click="show=true">{{ $t('profile.click') }}</a></van-col>
        </van-row>
        <div style="width:100%;margin: 10px 0 50px;" v-html="xuanfeidata.content"></div>
      </div>
    </div>
    <van-popup v-model="show" get-container="#app" v-if="show" round :style="{ height: '90%',width:'90%' }">
      <iframe :src="iframeSrc" frameborder="0" scrolling="auto" width="100%" height="100%"></iframe>
    </van-popup>
  </div>
</template>

<script>
import HeaderView from "@/components/Header";
export default {
  name: "ProfileView",
  components: { HeaderView },
  data() {
    return {
      xuanfeidata: {},
      gameitem:null,
      show:false,
      iframeSrc:null
    };
  },
  created() {
    this.getxuanfeidata();
    this.getGameItem()
  },
  methods: {
    getxuanfeidata() {
      this.$http({
        method: "get",
        url: "xuanfeidata",
        data: { id: this.$route.query.id },
      }).then((res) => {
        this.xuanfeidata = res.data;
      });
    },
    toserver() {
        this.$router.push({name:'service'})
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/login' })
      } else {
        this.$router.push({ path: '/lottery?key=' + key + "&id=" + id })
      }
    },
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = res.data[0];
        console.log(res.data)
        this.iframeSrc='/iframelottery?key=' + this.gameitem.key + "&id=" + this.gameitem.id
        console.log(this.iframeSrc)
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  margin: 10px 0;
  height: 42px;
  padding: 4px 10px;
  background: #000;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.tips{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;
    margin-top: 10px;
    span {
        background: linear-gradient(30deg,#7d76ef,#d63f8c);
    color: #fff;
    display: inline-block;
    border-radius: .33333rem;
    margin-right: .33333rem;
    font-size: 12PX;
    padding: .33333rem 1rem;
    margin-bottom: .33333rem
    }
}
</style>
